import classnames from "classnames";
import React from "react";

interface Props extends Pick<React.ImgHTMLAttributes<HTMLImageElement>, "alt" | "className" | "height" | "width"> {
  type: "light" | "dark" | "colour";
}

const defaultAlt = "TravelLocal is ABTA member P6930 - book with confidence.";

/**
 * The ABTA logo.
 * 
 * @status stable
 */
export const AbtaLogo: React.FC<Props> = ({ type, alt, className, ...rest }) => {
  const imgClassName = classnames("lazyload", "abta-logo", `abta-logo--${type}`, className);
  const altText = alt ?? defaultAlt;
  const path = `/images/logos/ABTA_logo_${type}.svg`;

  return (
    <img {...rest} className={imgClassName} alt={altText} title={altText} data-src={path} />
  );
};

AbtaLogo.defaultProps = {
  alt: defaultAlt,
};
